// extracted by mini-css-extract-plugin
module.exports = {"c":"styles_c__1wf9-","front":"styles_front__Pybvv","back":"styles_back__1NExu","container":"styles_container__1kvBo"};